import { createSlice } from '@reduxjs/toolkit';

// creat logs slice to track the user activity
interface LogAction {
    type: string;
    payload: any;
}
const logSlice = createSlice({
    name: 'log',
    initialState: {
        logs: [] as any[]
    },
    reducers: {
        addLog: (state, action: LogAction) => {
            state.logs.push(action.payload);
        },
        clearLogs: (state) => {
            state.logs = [];
        }
    }
});

export const { addLog, clearLogs } = logSlice.actions;

export default logSlice.reducer;
